// Generated with util/create-component.js
import Column from './Column';

export default Column;
